// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"KeyValueListInputItem-itemContainer-2g1bS","keyInput":"KeyValueListInputItem-keyInput-3YYEs","valueInput":"KeyValueListInputItem-valueInput-3zlQA"};